import { ContentClass } from '../enums';
// https://www.30secondsofcode.org/js/s/slugify
export const slugify = (str = '') => str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // remove non-word, non-space characters before `-`
    .replace(/[\s+-]+/g, '-') // internal spaces to `-`
    .replace(/^-+|-+$/g, ''); // remove (leading) `-`
export function titleCase(str) {
    const splitStr = str.toLowerCase().split(' ');
    const titleCased = splitStr.map((word) => {
        if (word === 'davinci') {
            return 'DaVinci';
        }
        return word.charAt(0).toUpperCase() + word.substring(1);
    });
    // Directly return the joined string
    return titleCased.join(' ');
}
export const isCollectionItemNew = (collectionItem) => {
    if (!collectionItem || !collectionItem.dateAdded) {
        return false;
    }
    const dateAdded = collectionItem.dateAdded;
    const utcDateAdded = new Date(dateAdded);
    const millisecondsInASecond = 1000;
    const secondsInADay = 86400;
    const dateToNumber = (date = new Date()) => Date.parse(String(date));
    const getDaysSinceDateAdded = Math.floor(Math.abs(dateToNumber(utcDateAdded) - dateToNumber()) /
        millisecondsInASecond /
        secondsInADay);
    return getDaysSinceDateAdded < 100;
};
export function urlSegmentForContentClass(contentClass) {
    switch (contentClass) {
        case ContentClass.Video:
            return 'video';
        case ContentClass.Audio:
            return 'audio';
        case ContentClass.Image:
            return 'images';
        default:
            return null;
    }
}
export function getCookieByName(name) {
    const cookies = document.cookie.split(';');
    const namedCookie = cookies.find((cookie) => cookie.startsWith(`${name}=`));
    if (namedCookie) {
        return namedCookie.split('=')[1];
    }
    const builderCookie = cookies.find((cookie) => cookie.startsWith(`b_${name}=`));
    if (builderCookie) {
        return builderCookie.split('=')[1];
    }
    return '';
}
/**
 * Defers the given task to run after the next frame is rendered.
 * This helper allows us to punt potentially taxing logic that might otherwise
 * cause the current frame to get delayed.
 *
 * Duplicated from StockBlocks.
 *
 * @see https://web.dev/articles/optimize-inp#yield_to_allow_rendering_work_to_occur_sooner
 * @param callback
 */
export default function deferToNextFrame(callback) {
    requestAnimationFrame(() => {
        setTimeout(callback, 0);
    });
}
